const PersonalDetails = ({ data }) => {
  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "170px 1fr",
    alignItems: "center",
    marginBottom: "6px",
    fontSize: "12px",
  };

  return (
    <div className="form-body">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div style={{ width: "75%" }}>
          <div style={rowStyle}>
            <strong>Serial Id</strong>
            <span>{data.id || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>URN No.</strong>
            <span>{data.urn || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Name</strong>
            <span style={{ textTransform: "capitalize" }}>
              {data.applicant_name || "N/A"}
            </span>
          </div>

          <div style={rowStyle}>
            <strong>Email</strong>
            <span>{data.applicant_email || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Phone</strong>
            <span>{data.applicant_mobile || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Whatsapp No.</strong>
            <span>{data.whatsapp_number || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Gender</strong>
            <span>{data.gender === 1 ? "Male" : "Female"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Religion</strong>
            <span>{data.religion || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Category</strong>
            <span>{data.category || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Subcategory</strong>
            <span>{data.subcategory || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Date of Birth</strong>
            <span>{data.dob || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Aadhar</strong>
            <span>{data.aadhar || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Father Name</strong>
            <span style={{ textTransform: "capitalize" }}>
              {data.father_name || "N/A"}
            </span>
          </div>

          <div style={rowStyle}>
            <strong>Father Mobile</strong>
            <span>{data.father_mobile || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Mother Name</strong>
            <span style={{ textTransform: "capitalize" }}>
              {data.mother_name || "N/A"}
            </span>
          </div>

          <div style={rowStyle}>
            <strong>Fees</strong>
            <span>{data.fees || "N/A"}</span>
          </div>

          <div style={rowStyle}>
            <strong>Subjects</strong>
            <span>{data.compulsory_subjects || "N/A"}</span>
          </div>
        </div>

        <div
          style={{
            width: "20%",
            textAlign: "center",
          }}
        >
          <img
            src={`https://campus.acetians.in/custom/uploads/${data.image_file}`}
            alt="Applicant"
            style={{
              width: "100px",
              height: "130px",
              objectFit: "cover",
              border: "1px solid #ccc",
            }}
          />

          <br />
          <br />

          <img
            src={`https://campus.acetians.in/custom/uploads/${data.signature_file}`}
            alt="Signature"
            style={{
              width: "100px",
              height: "40px",
              objectFit: "contain",
              border: "1px solid #ccc",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;